export default {
  FETCHED_ALL: 'FETCHED_ALL_ACCOUNTS',
  FETCHED_MULTIPLE: 'FETCHED_ACCOUNTS',
  FETCHED_SINGLE: 'FETCHED_ACCOUNT',
};
